import { render, staticRenderFns } from "./LoyaltyNotifyUpsert.vue?vue&type=template&id=e4c3a03a"
import script from "./LoyaltyNotifyUpsert.vue?vue&type=script&lang=js"
export * from "./LoyaltyNotifyUpsert.vue?vue&type=script&lang=js"
import style0 from "./LoyaltyNotifyUpsert.vue?vue&type=style&index=0&id=e4c3a03a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports